import { Effect, Layer, Scope } from "effect";
import { EditorJsonIo } from "./json-service.ts";
import { EditorPlatform } from "./platform-service.ts";
import { EditorPlatformLive } from "./platform-live.ts";
import { editorHighlightDependencyFailure } from "./highlight-model.ts";
import { EditorHighlightIo } from "./highlight-service.ts";

export const EditorHighlightIoLive = Layer.effect(EditorHighlightIo, Effect.gen(function* () {
  const platform = yield* EditorPlatform, json = yield* EditorJsonIo, owner = yield* Scope.Scope;
  const syntax = yield* Effect.cached(json.acquire({ _tag: "Tokens" }).pipe(Effect.provideService(Scope.Scope, owner), Effect.mapError(editorHighlightDependencyFailure)));
  const load = yield* Effect.cached(Effect.tryPromise({ try: () => import("./highlight-monaco-live.ts"), catch: editorHighlightDependencyFailure }));
  return EditorHighlightIo.of({
    colorize: Effect.fn("Frontend.EditorHighlightIo.lazyColorize")(function* (text, language) {
      yield* platform.ready.pipe(Effect.mapError(editorHighlightDependencyFailure));
      const selected = language === "json" ? (yield* syntax).languageId : language;
      return yield* (yield* load).colorizePreview(text, selected);
    })
  });
})).pipe(Layer.provide(EditorPlatformLive));
